export default __webpack_public_path__ + "assets/models/f7a4074552eacbfc6f10edea3fb4ca6c.glb";